module.exports = __webpack_public_path__ + "img/recordfu-title.c1f92451.png";